export default __webpack_public_path__ + "static/media/alarm.e23ae8cf.svg";